import { Space, Table } from "antd";
import {
  ExpandSearch,
  ListActionButton,
  Notification,
} from "components/common";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { columnTable, dataField } from "./ReportOrthorK.config";
import ModalDetail from "./ModalDetail/ModalDetail";
import { employeeService, examOutService, refraction } from "api";
import { formatDateToString } from "helper/common";
import { FORMAT_TIME, tabKeys } from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setDataOrthoK, setSelectedRowKeys } from "redux/reducer/pending";
import { setButtonsHeader } from "redux/reducer/common";
import "./ReportOrthorK.scss";
const ReportOrthorK = () => {
  const [totalPage, setTotalPage] = useState();
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  const data = useAppSelector((e) => e.pending.dataOrthoK);
  const [fields, setFields] = useState(dataField);
  const expandRef = useRef<any>();
  const [params, setParams] = useState<any>({
    limit: 50,
    page: 1,
    // ngayNhanKinhTu: dayjs(),
    // ngayNhanKinhDen: dayjs(),
  });
  // useEffect(() => {
  //   expandRef?.current.setFieldValue("ngayNhanKinhTu", params.ngayNhanKinhTu);
  //   expandRef?.current.setFieldValue("ngayNhanKinhDen", params.ngayNhanKinhDen);
  // }, []);
  const otthoKRef = useRef<any>();

  const onChangePagination = (page: number, pageSize: number) => {
    setParams({ ...params, page: page, limit: pageSize });
  };

  const onClickSearchButton = () => {
    const searchFields = expandRef.current?.getData();
    setParams({
      ...params,
      ...searchFields,
      page: 1,
    });
  };

  columnTable.map((e) => {
    if (e.key == "action") {
      e.render = (_, record, index) => {
        return (
          <ListActionButton
            showDetailFunction={() => handleOnShowDetail(record)}
            deleteFunction={() => handleOnDelete(record)}
          ></ListActionButton>
        );
      };
    }
    if (e.key == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (params.page - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const handleOnShowDetail = async (record) => {
    try {
      const res = await refraction.getByIdOthorK(record.id);
      otthoKRef.current.setIsShowModal(true);
      otthoKRef.current.setTypeModal(false);
      otthoKRef.current.setDataOthorK(res);
      otthoKRef.current.setDataTable(res?.ketQuaDieuTriOrthoK);
    } catch (error) {
      Notification("error", "Lấy thông tin chi tiết không thành công");
    }
  };

  const handleOnDelete = async (record) => {
    try {
      await refraction.deleteByIdOthorK(record.id);
      const newData = data.filter((e) => e.id !== record.id);
      dispatch(setDataOrthoK(newData));
      Notification("success", "Xoá bệnh nhân không thành công");
    } catch (error) {
      Notification("error", "Xoá bệnh nhân không thành công");
    }
  };

  const paginationConfig = {
    current: params.page,
    total: totalPage,
    pageSize: params.limit,
    onChange: onChangePagination,
  };

  //Lấy danh sách bệnh nhân
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await refraction.getListDataOthorK(fomartParams());
      dispatch(
        setDataOrthoK(
          res.map((e) => ({
            ...e,
            key: e.id,
          }))
        )
      );
      setTotalPage(res.length);
      setLoading(false);
    } catch (error) {
      Notification("error", "Không lấy được danh sách bệnh nhân");
      setLoading(false);
    }
  };

  const fomartParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayNhanKinhTu: formatDateToString(params.ngayNhanKinhTu),
      ngayNhanKinhDen: formatDateToString(params.ngayNhanKinhDen),
    };
  };
  const activeTab = useAppSelector((e) => e.common.activeTab);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (activeTab === tabKeys.REFRACTION.REPORT_ORTHOR_K) {
      dispatch(setSelectedRowKeys([]));
      fetchData();
      dispatch(setButtonsHeader([]));
    }
  }, [params, activeTab]);

  // useEffect(() => {
  //   getLisDoctor();
  //   getListCNKhucXa();
  // }, []);
  // const getLisDoctor = async () => {
  //   try {
  //     const response = await examOutService.getLisDoctor();
  //     //console.log("Nguồn", response.data);
  //     fields.find((e) => e.name == "bacSi").options = response.data.map((e) => {
  //       return { value: e.hoTen, label: e.hoTen };
  //     });
  //     setFields([...fields]);
  //   } catch (error) {
  //     Notification("error", "Lỗi xảy ra khi lấy thông tin danh mục bác sĩ");
  //   }
  // };
  // const getListCNKhucXa = async () => {
  //   try {
  //     const datass= {idChucVu:25,trangThai:"0",page:1,limit:99}
  //     const response = await employeeService.searchEmployee(datass);
  //     // console.log("danh sách", response.items);
  //     fields.find((e) => e.name == "cuNhanKhucXa").options = response.items.map((e) => {
  //       return { value: e.hoTen, label: e.hoTen };
  //     });
  //     setFields([...fields]);
  //   } catch (error) {
  //     Notification("error", "Lỗi xảy ra khi lấy thông tin danh mục cử nhân");
  //   }
  // };
  return (
    <div className="report-orthoK-tab-container">
      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <ExpandSearch
            fields={fields}
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            onReset={onClickSearchButton}
            initialValues={params}
            isSearchExpend={false}
          ></ExpandSearch>
        </Space>
      </div>
      <div className="container">
        <Table
          className="table-orthoK"
          bordered
          pagination={paginationConfig}
          dataSource={data}
          loading={loading}
          columns={columnTable}
          scroll={{
            y: 600,
            x: 1800,
          }}
          sticky
        />
      </div>
      <ModalDetail ref={otthoKRef} />
    </div>
  );
};

export default ReportOrthorK;
